export default {
  version: "1.0.0",
  timezone: "America/Sao_Paulo",
  language: "pt-br",
  // timeout: 60000,
  timeout: 99990000,
};
